import * as React from 'react'
// libs
import styled from 'styled-components'
// components
import { ReduxSelect, ReduxSwitch } from 'components/FormElements/ReduxForm'
import { Collapse as CollapseOrigin } from 'components/UI'
// constants
import { PROFILE_SELECT_OPTIONS } from 'constants/security'
// themes
import { colors } from 'themes/index'
// types
import { FieldType } from 'types/graphql'

// styled
const Collapse = styled(CollapseOrigin)`
  padding: 8px 0;
  margin: 0;

  svg {
    margin-left: -8px;
  }
`

const SelectWrapper = styled('div')`
  align-items: center;
  color: ${colors.gray400};
  display: flex;
  font-size: 16px;
  height: 38px;
  justify-content: space-between;

  > :last-child {
    width: 88px;
  }
`

// types
interface SecurityProfileOption {
  label: string
  name: string
  type: string
}

interface Props {
  isLocked?: boolean
  isSkeftoAdmin?: boolean
  label: string
  options: SecurityProfileOption[]
}

const ProfileFunctions: React.FC<Props> = ({ isLocked, isSkeftoAdmin, label, options }) => {
  const [isCollapsed, setExpanded] = React.useState<boolean>(false)

  const handleCollapse = () => setExpanded(!isCollapsed)

  return (
    <>
      <Collapse isCollapsed={isCollapsed} handleClick={handleCollapse}>
        {`${label} Functions`}
      </Collapse>

      {!isCollapsed &&
        options.map((option) => {
          if (option.type === FieldType.Switch) {
            const isOptionLocked =
              (option.name === 'reporting' && isLocked) ||
              (label === 'the Data Hub' && isLocked) ||
              (option.name === 'reportingRefresh' && !isSkeftoAdmin)

            return (
              <ReduxSwitch
                disabled={isOptionLocked}
                isLocked={isOptionLocked}
                justifyContent={'space-between'}
                key={option.label}
                label={option.label}
                name={option.name}
              />
            )
          }

          if (option.type === FieldType.PickList) {
            return (
              <SelectWrapper key={option.label}>
                {option.label}
                <ReduxSelect name={option.name} options={PROFILE_SELECT_OPTIONS} />
              </SelectWrapper>
            )
          }
        })}
    </>
  )
}

export default ProfileFunctions
